import type { PageConfig, PageConfigServiceInterface } from './types/ConfigTypes';

/**
 * * PageConfigService
 * @description Service to set and get configurations for page level
 *
 * * @function getPageConfigs
 *   @returns Object with configurations
 *   @description to get environment configurations
 * * @function setPageConfigs
 *   @param PageConfigs
 *   @type Object
 *   @description: to set configurations data
 */
const PageConfigService: PageConfigServiceInterface = (function (root, factory) {
  let pageConfigService: PageConfigServiceInterface = {} as PageConfigServiceInterface;
  if (root) {
    // If instance exists use it otherwise create new.
    if (root.PageConfigService) {
      ({ PageConfigService: pageConfigService } = root);
    } else {
      root.PageConfigService = pageConfigService;
      return factory(pageConfigService);
    }
  }

  return pageConfigService;
})(
  (typeof window === 'object' && window) || (typeof globalThis === 'object' && globalThis) || this,
  function (PageConfigService: PageConfigServiceInterface) {
    let configProxy: PageConfig = {};

    const getPageConfigs = () => configProxy;

    const setPageConfigs = (configs: PageConfig) => {
      configProxy = Object.assign(configProxy, configs);
    };

    // Adding methods to Instance.
    PageConfigService.getPageConfigs = getPageConfigs;
    PageConfigService.setPageConfigs = setPageConfigs;

    return PageConfigService;
  },
);

export { PageConfigService };
export type { PageConfig };
